import * as Yup from 'yup';
import DomPurify from 'dompurify';
import { TemplateRawFormField } from '../interfaces/template-raw-form';
import { TemplateFormFieldValidation } from '../interfaces/template-form';
import { TemplateFormFieldValidationType } from '../interfaces/template-form-validation';
import { TEMPLATE_FORM_FIELD_VALIDATION_REGISTRY } from '../registry/validation-registry/templateFormValidationRegistry';

export function TemplateFormFieldValidationsFactory(
  field: TemplateRawFormField,
  validator: Yup.MixedSchema
) {
  const validations: TemplateFormFieldValidation[] = [];

  if (field.required) {
    validations.push({
      type: TemplateFormFieldValidationType.REQUIRED
    });
  }

  (field.validations || []).forEach(validation => {
    validations.push({
      type: validation.type,
      value: validation.value,
      errorMessage: DomPurify.sanitize(validation.error_message || '')
    });
  });

  if (validations.length === 0) {
    return Yup.object().shape({
      [field.name]: validator.nullable()
    });
  }

  return Yup.object().shape({
    [field.name]: fieldYupSchemaBuilder(validations, validator)
  });
}

function fieldYupSchemaBuilder(
  validations: TemplateFormFieldValidation[],
  validator: Yup.Schema<unknown>
) {
  let schemaValidator = validator;

  validations.forEach(validation => {
    const validationRegistry = TEMPLATE_FORM_FIELD_VALIDATION_REGISTRY[validation.type];

    schemaValidator = validationRegistry(schemaValidator, validation);
  });

  return schemaValidator;
}
